export default {
  methods: {
    numberOnly(event, type) {
      var val = event.toString().trim();
      var result;

      if (typeof val === "string") {
        result = val.replace(/\D/g, "");
      }
      if (type == "hour") {
        result = parseFloat(result);
        if (result >= 24) {
          result = 23;
        }
      } else if (type == "minute") {
        result = parseFloat(result);
        if (result >= 60) {
          result = 59;
        }
      }
      return result;
    },
  },

  async sendMessage(message, options) {
    try {
      if (this.$liff.isInClient()) {
        // eslint-disable-next-line no-undef
        return await this.$liff.sendMessages([
          {
            type: "text",
            text: message,
          },
        ]);
      } else {
        alert("Not in client");
        // try {
        //   await this.sendMessageWithQuota(message, options);
        // } catch (error) {
        //   // eslint-disable-next-line no-console
        //   console.error(error);
        // }
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      alert(error.toString());

      //   try {
      //     await this.sendMessageWithQuota(message, options);
      //   } catch (error) {
      //     // eslint-disable-next-line no-console
      //     console.error(error);
      //   }
    }
  },
  async sendMessageWithQuota(message, options) {
    let { userid, sessiontoken, pageid } = options;
    let response = await axios.post(
      this.$store.state.serverUrl + `line/${pageid}/send-message`,
      {
        userid: userid,
        sessiontoken: sessiontoken,
        message: message,
      },
      {
        params: {},
        headers: {
          AUTHORIZATION: "Bearer xxx xxx",
          "x-api-key": this.$store.state.serverApiKey,
        },
        responseType: "arraybuffer",
      }
    );
    return response;
  },
};
